function updateCounty(sender) {
    var countySource = $("[county-source]");
    var countyUuid = sender.getAttribute("county-id");
    var url = $(sender).data('url');

    $.ajax({
        url: url
    });


    countySource.val(countyUuid);
    countySource.trigger('change');

    $("#changeMyCounty .daat-modal-closer").click();

    location.reload();
}


function setupSearch() {
    var countySource = $("[county-source]");

    var countyListeners = [];

    $("select[county-listener=1]").each(function (index, element) {
        countyListeners.push(new SelectFilter(element.id, "county"));
    });

    $("a[county-listener=1]").each(function (index, element) {
        countyListeners.push(new TextUpdater(element, "County Data", false));
    });

    countySource.on("change", function () {
        var newCountyName = countySource.find(":selected").text().toLowerCase();
        var newCountyUuid = countySource.find(":selected").val();

        for (var i = 0; i < countyListeners.length; i++) {
            var listener = countyListeners[i];

            listener.update(newCountyName);
        }

        // $.get("/county/" + newCountyUuid + "/info", function (data) {
        //     var instrumentCount = data.instrument_count;
        //     var highFileDate = data.high_file_date.date;
        //
        //     var formattedCount = instrumentCount.toLocaleString('en-US');
        //     var formattedDate = new Date(highFileDate).toLocaleDateString();
        //
        //     $("#county_instruments").text(formattedCount);
        //     $("#county_high_file_date").text(formattedDate);
        // });
    });

    var documentTypeListeners = [];

    $("select[document-type-listener=1]").each(function (index, element) {
        documentTypeListeners.push(new SelectFilter(element.id, "category"));
    });

    $("[label-listens]").parent().find("label").each(function (index, element) {
        documentTypeListeners.push(new TextUpdater(element, "Doctype:", true));
    });

    var documentTypeSource = $("[document-type-source] input[type=radio]");

    documentTypeSource.on('change', function () {
        var newType = this.value;

        for (var i = 0; i < documentTypeListeners.length; i++) {
            var listener = documentTypeListeners[i];

            listener.update(newType);
        }
    });

    //We trigger this at start so we have the initial value.
    countySource.trigger('change');

    $("[document-type-source] [checked]").trigger('change');
}